<template>
    <div class="academicDegreeRecord">
        <div class="academicDegreeRecord-box">
            <div class="search">
                <el-form
                    ref="search"
                    :inline="true"
                    :model="condition"
                    :rules="rules"
                    label-width="80px"
                    style="display: flex; justify-content: space-between"
                >
                    <div>
                        <!-- <el-form-item>
                            <el-input v-model="condition.student_code" placeholder="请输入学号" clearable></el-input>
                        </el-form-item> -->
                        <el-form-item prop="identity">
                            <el-input v-model="condition.identity" placeholder="请输入身份证" clearable></el-input>
                        </el-form-item>
                        <!-- <el-form-item>
                            <el-input v-model="condition.candidate_number" placeholder="请输入考生号" clearable></el-input>
                        </el-form-item> -->
                        <el-form-item prop="verify_code">
                            <el-input v-model="condition.verify_code" placeholder="请输入验证码" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <img class="img" :src="codeImg" @click="getCodeData" alt="" height="40">
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="loadData">搜索</el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <el-table
                v-if="isShowTable"
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                :data="tableData"
                border
                style="width: 100%;margin-top: 20px;"
            >
                <el-table-column prop="is_issue" align="center" label="是否发放证书">
                    <template slot-scope="scope">
                        <span>{{scope.row.is_issue == 1 ? '是' : '否'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="audit_status" align="center" label="审核状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.audit_status | auditStatusStyle">
                            <span>{{scope.row.audit_status | auditStatusFilter}}</span>
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="audit_content" align="center" label="拒绝理由"></el-table-column>
                <el-table-column prop="is_issue" align="center" label="发放证书状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.is_issue | isIssueStatusStyle">
                            <span>{{scope.row.is_issue | isIssueFilter}}</span>
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="student_title" align="center" label="学生姓名">
                    <template slot-scope="{ row }">
                        <!-- class="link" @click="isPersonalShow(row)" -->
                        <span>{{ row.student_title }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="source_type" align="center" label="学生来源">
                    <template slot-scope="scope">
                        <span>{{scope.row.source_type | sourceTypeFilter}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="tel" align="center" label="移动电话"></el-table-column>
                <el-table-column prop="sex_title" align="center" label="性别"></el-table-column>
                <el-table-column prop="nat_title" align="center" label="民族"></el-table-column>
                <el-table-column prop="pol_title" align="center" label="政治面貌"></el-table-column>
                <el-table-column prop="date_birth" align="center" label="出生日期"></el-table-column>
                <el-table-column prop="identity" align="center" label="身份证"></el-table-column>
                <el-table-column prop="pro_title" align="center" label="专业名称"></el-table-column>
                <el-table-column prop="degree_title" align="center" label="学位名称"></el-table-column>
                <el-table-column prop="exam_number" align="center" label="考生号或准考证号"></el-table-column>
                <el-table-column prop="student_code" align="center" label="学号"></el-table-column>
                <el-table-column prop="edu_system" align="center" label="学制"></el-table-column>
                <el-table-column prop="study_title" align="center" label="学习形式"></el-table-column>
                <el-table-column prop="admission_date" align="center" label="入学年月"></el-table-column>
                <el-table-column prop="gra_date" align="center" label="毕业年月"></el-table-column>
                <!-- <el-table-column prop="obtain_date" align="center" label="获学位日期"></el-table-column> -->
                <el-table-column prop="english_at" align="center" label="学位英语考试时间"></el-table-column>
                <el-table-column prop="english_img" align="center" label="学位英语考试合格证照片">
                    <template slot-scope="scope">
                        <el-image
                            v-if="!$base.isNull(scope.row.english_img)"
                            class="see-img"
                            :src="scope.row.english_img"
                            :preview-src-list="[scope.row.english_img]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="computer_at" align="center" label="计算机等级考试时间"></el-table-column>
                <el-table-column prop="computer_img" align="center" label="计算机等级考试合格证照片">
                    <template slot-scope="scope">
                        <el-image
                            v-if="!$base.isNull(scope.row.computer_img)"
                            class="see-img"
                            :src="scope.row.computer_img"
                            :preview-src-list="[scope.row.computer_img]">
                        </el-image>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="degree_number" align="center" label="学位证书编号"></el-table-column> -->
                <el-table-column prop="computer_img" align="center" label="学位证书用电子照片">
                    <template slot-scope="scope">
                        <el-image
                            v-if="!$base.isNull(scope.row.degree_img)"
                            class="see-img"
                            :src="scope.row.degree_img"
                            :preview-src-list="[scope.row.degree_img]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="average_score" align="center" label="平均成绩"></el-table-column>
                <el-table-column prop="paper_score" align="center" label="论文成绩"></el-table-column>
                <el-table-column prop="score_img" align="center" label="成绩总表">
                    <template slot-scope="scope">
                        <el-image
                            v-if="!$base.isNull(scope.row.score_img)"
                            class="see-img"
                            :src="scope.row.score_img"
                            :preview-src-list="[scope.row.score_img]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="grad_img" align="center" label="毕业证内页照">
                    <template slot-scope="scope">
                        <el-image
                            v-if="!$base.isNull(scope.row.grad_img)"
                            class="see-img"
                            :src="scope.row.grad_img"
                            :preview-src-list="[scope.row.grad_img]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" align="center" label="备注"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import {studentDaRecord} from "@/api/degreeApplication";
import {verifyCode} from "@/api/common";
export default {
    name: 'academicDegreeRecord',
    filters: {
        // 学生来源
        sourceTypeFilter(v){
            let obj = {
                1: '成教上清寺高教自考辅导学', 
                2: '成教其他', 
                3: '自考普通本科', 
                4: '自考其他',
            };
            return obj[v];
        },
        // 发放状态
        isIssueFilter(v){
            let obj = {
                0: '未发放',
                1: '已发放', 
            }
            return obj[v];
        },
        // 发放状态 样式
        isIssueStatusStyle(v){
            let obj = {
                0: 'danger', 
                1: 'success',  
            };
            return obj[v];
        },
        // 审核状态
        auditStatusFilter(v){
            let obj = {
                0: '待审核',
                1: '通过', 
                2: '未通过', 
            }
            return obj[v];
        },
        // 审核状态 样式
        auditStatusStyle(v){
            let obj = {
                0: '', 
                1: 'success', 
                2: 'danger', 
            };
            return obj[v];
        },
    },
    data(){
        return {
            tableData: [],
            isShowTable: false,
            condition: {
                // student_code: '',  //学号
                identity: '', //身份证
                // candidate_number: '',  //考生号
                verify_token: '', 
                verify_code: '',  
            },
            rules: {
                identity: [{ required: true, message: '请输入身份证', trigger: 'blur' }],
                verify_code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
            },
            codeImg: null,  //验证图片
        };
    },
    created(){
        // this.getdata(); 
        this.getCodeData();
    },
    methods: {
        // 获取验证码
        getCodeData(){
            verifyCode().then(res => {
                const { img, verify_token } = res.result;
                this.codeImg = img;
                this.condition.verify_token = verify_token;
            });
        },
        loadData(){
            this.$refs['search'].validate((valid) => {
                if (valid) {
                    this.getdata();
                }
            });
        },
        getdata(){
            let data = this.condition;
            studentDaRecord(data).then(res => {
                if(res.code == 200){
                    this.tableData = res.result;
                    this.isShowTable = true;
                }
            }).finally(() => {
                this.getCodeData();
            });
        },       
    },
}
</script>

<style lang="scss" scoped>
.academicDegreeRecord{
    padding: 20px;
    height: 100vh;
    overflow-y: auto;
    .academicDegreeRecord-box{
        background-color: #fff;
        padding: 20px;
    }
}
</style>